import { Pipe, PipeTransform } from '@angular/core';

/// https://github.com/markedjs/marked
import { marked } from "marked";
/// https://github.com/cure53/DOMPurify
import DOMPurify from 'dompurify';


@Pipe({
    name: 'marked',
    standalone: true
})
export class MarkedPipe implements PipeTransform {

    constructor() {
    }

    async transform(value: string): Promise<string> {
        if (!value) {
            return '';
        }
        return DOMPurify.sanitize(await marked.parse(value));
        ;
    }

}
